<app-data-table mainTitle="Motivos para dispensa Nif"
                singleTitle="Motivos para dispensa Nif"
                routerPath="/siscoserv/nao-nif"
                entityPath="/tbnaonif"
                [entity]="tbNaoNif"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
